export const CONFIG_PATH = "configs/";
